export default "__VITE_ASSET__4760ef9d__"